import React from 'react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { ReactComponent as NoDocument } from '../../assets/Icons/lucideIcons/file-search-corner.svg';
import startCase from 'lodash/startCase';

const NoDataPresentComponent = ({
  message = 'No data Present.',
  Icon = NoDocument,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        flexDirection: 'column',
        color: (theme) => theme.palette.primary.main, // Set the color context
      }}
    >
      <Icon />
      <Typography
        variant="subtitle1"
        noWrap
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '600px',
        }}
        title={message}
      >
        {startCase(message)}
      </Typography>
    </Box>
  );
};

NoDataPresentComponent.propTypes = {
  message: PropTypes.string.isRequired,
  Icon: PropTypes.elementType,
};

export default NoDataPresentComponent;
